import {useTranslation} from 'react-i18next';
import {useHistory, useLocation} from 'react-router-dom';
import {AppScreen} from './AppScreen';
import {Logo} from './Logo'
import {Headline} from './Headline'
import {useAuth} from './useAuth';
import {useCases} from './useApi';
import {CaseTable} from './CaseTable';
import {Modal} from './Modal';
import {ApproveCollaborationScreen} from './ApproveCollaborationScreen.js';

export const ReviewCasesScreen = (props) => {
  const {t} = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const hash = location.hash;
  const selectedCaseId = hash ? hash.replace(/^#/, '') : null;
  const cases = useCases();

  const onRowClicked = row => {
    history.push('#' + row.id);
  };

  const onRequestClosed = () => {
    history.push('#');
  };

  return (
    <AppScreen className="ReviewCasesScreen" modal={selectedCaseId && <Modal><ApproveCollaborationScreen caseId={selectedCaseId} onClose={onRequestClosed}/></Modal>}>
      <Logo/>
      <Headline>{t('ReviewCasesScreen.headline')}</Headline>
      <div className="AllCasesTable">
        <CaseTable
          cases={cases}
          onRowClicked={onRowClicked}
        />
      </div>
    </AppScreen>
  );
};

export default ReviewCasesScreen;
